/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import { FormattedMessage, IntlShape } from "react-intl";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Column } from "react-table";
import moment from "moment";

import { ReactComponent as GuestAccessIcon } from "assets/images/icons/TopNavIcons/GuestAccess.svg";
import { getLabelWithTranslationFallback } from "helpers/getLabel";
import getCommonShipmentColumns from "pages/common/Shipments/ShipmentColumns";

function formatDates(date: any, includeTime: boolean = false) {
  if (date === "ASAP") return "ASAP";
  if (includeTime) return moment(date).format("DD MMM YYYY HH:mm");
  return moment(date).format("DD MMM YYYY");
}

const getProviderShipmentColumns = (intl: IntlShape, handleOpenGuestAccessDialog: Function) => {
  const columns: Column[] = [
    ...getCommonShipmentColumns(intl, null, false, false),
    {
      Header: intl.formatMessage({
        id: "general.shipper",
        defaultMessage: "Shipper",
      }),
      group: intl.formatMessage({
        id: "columns.basic",
        defaultMessage: "Basic",
      }),
      accessor: "payment_location",
      sortable: true,
      Cell: ({ value, row }: any) => (
        <>
          <p className="mb-0 font-b4">{row.original?.shipper}</p>
          <span className="text-primary">{value}</span>
        </>
      ),
    },
    {
      Header: getLabelWithTranslationFallback("Confirmation time", {
        translation: intl.formatMessage({
          id: "new-request.quote-confirmation.schedule.confirmationDate",
          defaultMessage: "Confirmation date",
        }),
        returnAsString: true,
        withoutInfo: true,
      }),
      group: intl.formatMessage({
        id: "columns.basic",
        defaultMessage: "Basic",
      }),
      sortable: true,
      accessor: "confirmation_datetime",
      Cell: ({ value }) => {
        const time = moment(value).format("HH:mm");
        return <div>{value ? `${formatDates(value)} - ${time}` : "-"}</div>;
      },
    },
    {
      Header: intl.formatMessage({ id: "tableHeaders.expectedPickupDateTime", defaultMessage: "Expected pickup date time" }),
      group: intl.formatMessage({
        id: "columns.schedule",
        defaultMessage: "Schedule",
      }),
      accessor: "expected_pickup_datetime",
      Cell: ({ value }) => <div>{value || "-"}</div>,
    },
    {
      Header: intl.formatMessage({
        id: "tableHeaders.expectedDeliveryDateTime",
        defaultMessage: "Expected delivery date time",
      }),
      group: intl.formatMessage({
        id: "columns.schedule",
        defaultMessage: "Schedule",
      }),
      accessor: "expected_delivery_datetime",
      Cell: ({ value }) => <div>{value || "-"}</div>,
    },
    {
      Header: intl.formatMessage({ id: "tableHeaders.quotationsBooked", defaultMessage: "Quotations booked" }),
      accessor: "related_shipments_count",
      group: intl.formatMessage({
        id: "columns.schedule",
        defaultMessage: "Schedule",
      }),
      Cell: ({ value }) => <div>{value || "-"}</div>,
    },
    {
      Header: intl.formatMessage({ id: "quote-request-detail.pickupCompany", defaultMessage: "Pickup Company" }),
      group: intl.formatMessage({
        id: "columns.other",
        defaultMessage: "Other",
      }),
      accessor: "origin",
      Cell: ({ value }) => <div>{value.origin_name || "-"}</div>,
    },
    {
      Header: intl.formatMessage({ id: "quote-request-detail.deliveryCompany", defaultMessage: "Delivery Company" }),
      group: intl.formatMessage({
        id: "columns.other",
        defaultMessage: "Other",
      }),
      accessor: "delivery",
      Cell: ({ value }) => <div>{value.destination_name || "-"}</div>,
    },
    {
      Header: intl.formatMessage({ id: "tableHeaders.team", defaultMessage: "Team" }),
      group: intl.formatMessage({
        id: "columns.other",
        defaultMessage: "Other",
      }),
      accessor: "team_name",
      Cell: ({ value }) => <div>{value || "-"}</div>,
    },
    {
      Header: "",
      accessor: "shipment_reference",
      group: intl.formatMessage({
        id: "columns.other",
        defaultMessage: "Other",
      }),
      actions: true,
      disableDrag: true,
      Cell: ({ row }: any) => {
        const { shipment_reference: shipmentId } = row.original;
        return (
          <div
            role="button"
            tabIndex={0}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 0 }}
              overlay={
                <Tooltip id="button-tooltip">
                  <FormattedMessage id="components.molecules.navigation.guestAccess" defaultMessage="Guest Access" />
                </Tooltip>
              }
            >
              <GuestAccessIcon
                onClick={() => handleOpenGuestAccessDialog(shipmentId)}
                height="18"
                width="18"
                className="mr-2"
              />
            </OverlayTrigger>
          </div>
        );
      },
    },
  ];

  return columns;
};

export default getProviderShipmentColumns;
